import React from "react";
import ReactSelect from "react-select";

const ReasonCodeSelector = ({
  reasonCodeOptions,
  selectedReasonCodes,
  onChange,
  isRequired = false,
  showValidation = false,
  placeholder = "Select reason codes..."
}) => {
  const hasError = isRequired && showValidation && (!selectedReasonCodes || selectedReasonCodes.length === 0);

  return (
    <div className="reason-codes-container">
      <ReactSelect
        name="selectedReasonCodes"
        className={`pers-reason-codes ${hasError ? 'error' : ''}`}
        options={reasonCodeOptions}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        value={selectedReasonCodes || []}
        onChange={onChange}
        allowSelectAll={false}
        placeholder={placeholder}
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: hasError ? '#d02f2f' : (state.isFocused ? '#007bff' : '#e6e8ed'),
            '&:hover': {
              borderColor: hasError ? '#d02f2f' : '#007bff'
            },
            boxShadow: state.isFocused 
              ? hasError 
                ? '0 0 0 3px rgba(208, 47, 47, 0.1)' 
                : '0 0 0 3px rgba(0, 123, 255, 0.1)'
              : 'none'
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: '#e3f2fd',
            borderRadius: '4px'
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: '#1976d2',
            fontWeight: '500'
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: '#1976d2',
            '&:hover': {
              backgroundColor: '#bbdefb',
              color: '#0d47a1'
            }
          })
        }}
      />
      {hasError && (
        <div style={{ 
          color: "#d02f2f", 
          marginTop: "8px", 
          fontSize: "14px",
          display: "flex",
          alignItems: "center"
        }}>
          Please select at least one reason code.
        </div>
      )}
    </div>
  );
};

export default ReasonCodeSelector;